import { Divider, Stack } from "@mui/material";
import { CardProps } from ".";
import { PaperBox } from "../../../../../../components/Layout/PaperBox";
import { DadoValorPrinter } from "../../../../../../components/BasicComponents/DisplayDados/DadoValorPrinter";
import { formatarCPFCNPJ, formatarTelefone } from "../../../../../../helpers/masks";

export default function CardDadosGerais({
    data
}: PropsCardDadosGerais) {
    return (
        <PaperBox>

            <DadoValorPrinter
                titulo="Nome"
                valor={`${data.id} - ${data.nome}`}
            />

            <DadoValorPrinter
                titulo="Cpf"
                valor={`${formatarCPFCNPJ(String(data.cpf))}`}
            />

            <DadoValorPrinter
                titulo="Crea"
                valor={`${data.crea}`}
            />

            <DadoValorPrinter
                titulo="Telefone"
                valor={`${formatarTelefone(data.telefone)}`}
            />


            <Divider sx={{ my: 2 }} />

            <Stack direction="row" justifyContent="space-between" alignItems="center">
                <DadoValorPrinter
                    titulo="Receitas emitidas"
                    valor={`${data.receitas_emitidas ?? 0}`}
                />

                <DadoValorPrinter
                    titulo="Receitas ART"
                    valor={`${data.quantidade_receitas_art ?? 0}`}
                />
            </Stack>

        </PaperBox>
    )
}

interface PropsCardDadosGerais extends CardProps { }
